export enum BusinessTypes {
  INDIVIDUAL = "individual",
  SOLEPROPRIETOR = "sole proprietor",
  LLCSINGLEMEMBER = "LLC - single member",
  CORPORATION = "corporation",
  CCORPORATION = "c corporation",
  SCORPORATION = "s corporation",
  PARTNERSHIP = "partnership",
  NONPROFIT = "non-profit",
  TRUSTESTATE = "trust/estate",
  LIMITEDLIABILITYCOMPANY = "limited liability company",
  SOLEPROPRIETORCOMPANY = "sole proprietor company",
}
